import { GetterTree } from 'vuex';
import { ITilesViewState, ITilesViewPage } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<ITilesViewState, RootState> = {
    pages(state): (deviceNumber: string) => ITilesViewPage[] {
        return (deviceNumber: string): ITilesViewPage[] => {
            const deviceState = state.devices[deviceNumber];
            if (deviceState) {
                return deviceState.pages;
            }
            return [];
        };
    },
};
